/**
 * mt-case-banner.js
 * Fullscreen case banner
 *
 * Only keeps lightweight section-local behavior:
 *  1. Scroll hint fades after the user starts scrolling
 *  2. Does not take over page-level scrolling
 *  3. Does not auto-snap or hand off to the next section
 */

(function () {
  'use strict';

  class MtCaseBanner {
    constructor(el) {
      this.section = el;
      this._init();
    }

    _init() {
      this._initScrollHintFade();
    }

    _getScrollParent(el) {
      let node = el.parentElement;

      while (node) {
        const style = getComputedStyle(node);
        const overflow = style.overflow + style.overflowY;

        if (/scroll|auto/.test(overflow)) return node;
        if (node === document.body || node === document.documentElement) {
          return document.documentElement;
        }

        node = node.parentElement;
      }

      return document.documentElement;
    }

    _initScrollHintFade() {
      const hint = this.section.querySelector('.mt-case-banner__scroll-hint');
      if (!hint) return;

      const scrollParent = this._getScrollParent(this.section);
      const onScroll = () => {
        const scrolled = scrollParent === document.documentElement
          ? window.scrollY
          : scrollParent.scrollTop;

        hint.style.opacity = scrolled > 10 ? '0' : '1';
      };

      const target = scrollParent === document.documentElement ? window : scrollParent;
      target.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initAll() {
    document.querySelectorAll('.mt-case-banner[data-section-id]').forEach((el) => {
      if (!el._mtCaseBanner) {
        el._mtCaseBanner = new MtCaseBanner(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('.mt-case-banner[data-section-id]');
    if (el && !el._mtCaseBanner) {
      el._mtCaseBanner = new MtCaseBanner(el);
    }
  });
})();
